import { Form, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  DirectSaleXFinancialFilterDateBy,
  DirectSaleXFinancialReportType,
} from '@/core/domain/questReport/Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';

const FieldFilterByDate: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const reportType = getFieldValue('reportType');

        return (
          <>
            {reportType === DirectSaleXFinancialReportType.overview && (
              <>
                <Title level={5}>
                  {intl.formatMessage({
                    id: 'movementDirectSaleXFinancial.form.filterByDate',
                  })}
                </Title>

                <Form.Item
                  name="filterDateBy"
                  noStyle
                  initialValue={DirectSaleXFinancialFilterDateBy.sale}
                >
                  <Radio.Group
                    optionType="button"
                    buttonStyle="solid"
                    size="large"
                  >
                    <Radio value={DirectSaleXFinancialFilterDateBy.sale}>
                      {intl.formatMessage({
                        id: 'movementDirectSaleXFinancial.form.filterByDate.directSale',
                      })}
                    </Radio>

                    <Radio value={DirectSaleXFinancialFilterDateBy.financial}>
                      {intl.formatMessage({
                        id: 'movementDirectSaleXFinancial.form.filterByDate.financial',
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </>
            )}
          </>
        );
      }}
    </Form.Item>
  );
};

export default FieldFilterByDate;
